import Vue from 'vue'
import Router from 'vue-router'

import Empty from '../components/Empty';
import DecryptHash from '../components/DecryptHash';

Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [
        { name: 'decrypt', path: '/counter/:hash', component: DecryptHash },
        { name: 'root', path: '/', component: Empty }
    ]
})